import { isAuthenticatedCustomer } from '@ori/auth';
import { formatToken } from "./prepareToken";
import { ACCEPT_LANGUAGE, AUTHORIZATION, CLIENT_APPLICATION, CONTENT_TYPE, CUSTOMER_CONTEXT, JSON_CONTENT, TENANT_CONTEXT } from "../constants";
/**
 * Utility function for generating core headers for HTTP requests. Returns object with headers.
 */
export const getHeaders = ({
  sourceAppName,
  language,
  customerId,
  tenant,
  token
} = {}) => {
  const headers = {
    [CONTENT_TYPE]: JSON_CONTENT
  };
  const formattedToken = formatToken(token);
  if (formattedToken) {
    headers[AUTHORIZATION] = formattedToken;
  }
  if (sourceAppName) {
    headers[CLIENT_APPLICATION] = sourceAppName;
  }
  if (language) {
    headers[ACCEPT_LANGUAGE] = language;
  }
  if (isAuthenticatedCustomer(customerId)) {
    headers[CUSTOMER_CONTEXT] = customerId.toString();
  }
  if (tenant) {
    headers[TENANT_CONTEXT] = tenant;
  }
  return headers;
};
//# sourceMappingURL=getHeaders.js.map